import { render, staticRenderFns } from "./SelectAlcancesObject.vue?vue&type=template&id=3768b165&scoped=true&"
import script from "./SelectAlcancesObject.vue?vue&type=script&lang=js&"
export * from "./SelectAlcancesObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3768b165",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
